import TextWithHashtags from './TextWithHashtags';

export default TextWithHashtags;
